// images files array
window.imagesFiles = [];
window.imagesIndex = 0;

$(function(){
	var inputEls = $('.form-photos input[type="file"]');

	for(var i = 0; i < inputEls.length; i++) {

		(function(){
			var inputEl 	= $(inputEls[i]);
			var wrapperEl = inputEl.closest('.form-photos');
			var itemsEl 	= wrapperEl.find('.form-photos__items');

			// on change upload image
			inputEl.on('change', function(){
				var thisEl = $(this);
				var maxPhotos = +thisEl.attr('data-max-count') ? +thisEl.attr('data-max-count') : 15;
				var maxMB     = +thisEl.attr('data-max-mb') ? +thisEl.attr('data-max-mb') : 10;


				// if images count more than max
				if(wrapperEl.find('.form-photos__item').length > maxPhotos) {
					alertify.setHeader('Внимание');
					alertify.alert('Максимально допустимое количество фото ' + maxPhotos);
					return;
				}


				// if there are files
				var files = this.files;
				var maxSizeError = false;
				for(var y = 0; y < files.length; y++){
					var file = files[y];

					if(file) {
						// if image is too big
						if(file.size > maxMB * 1024 * 1024) {
							maxSizeError = true;
							continue;
						}


						var imageReg = /\/(gif|jpg|jpeg|tiff|png)$/i;

						// if file is image
						if(imageReg.test(file.type)){
							// add image to images array
							imagesFiles[imagesIndex] = file;

							// add image preview
							(function(){
								var index = imagesIndex;
								var reader = new FileReader();
						    reader.onload = function (e) {
									itemsEl.append(
										`<div class="form-photos__item" data-image-index="` + index + `" data-upload-image><img src="` + e.target.result + `" alt=""/> 
											<button type="button" class="form-photos__delete"></button>
										</div>`
									);
									
						    };
								reader.readAsDataURL(file);
							})();
							
							// increase images files index
							imagesIndex++;
						}
					}
				}

				// show max file size error
				if(maxSizeError) {
					alertify.error('Максимально допустимый размер фото ' + maxMB + 'МБ');
				}

				// clear input
				this.value = null;
				this.files = null;
			});
		})();

	}
});